"use client";

import { ArrowRight, Zap, Shield, TrendingUp } from "lucide-react";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function SolutionsOverview() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const solutions = [{
    id: 1,
    icon: Zap,
    title: "Energy Infrastructure",
    description: "Mobile and immersion cooled mining systems designed for energy efficiency and carbon impact reduction.",
    link: "/InfrastructurePage"
  }, {
    id: 2,
    icon: Shield,
    title: "Risk Management",
    description: "Disciplined risk management and institutional governance standards for digital asset operations.",
    link: "#"
  }, {
    id: 3,
    icon: TrendingUp,
    title: "Digital Asset Trading",
    description: "Systematic digital asset strategies with operational expertise and capital deployment.",
    link: "/WIMCODigitalPage"
  }];
  return <section id="solutions-overview" ref={sectionRef} className="dark bg-background text-foreground py-24 px-4">
      <div className="mx-auto max-w-7xl">
        <div className={`mb-16 text-center transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          <h2 className="mb-4 font-display font-semibold text-[clamp(2rem,4.5vw,2.75rem)] leading-[1.3] tracking-tight">
            Solutions Overview
          </h2>
          <p className="mx-auto max-w-2xl leading-[1.6] text-muted-foreground">
            Integrated infrastructure and digital asset operations with disciplined governance
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {solutions.map((solution, i) => <Card key={solution.id} data-index={i} className={`group relative overflow-hidden border-[var(--border-thin)] border-border bg-background p-8 rounded-[var(--radius-sm)] shadow-soft hover:shadow-medium hover:border-primary/40 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`} style={{
          transitionDelay: `${i * 100}ms`
        }}>
              <CardHeader className="px-0 pt-0 pb-6">
                <div className="mb-4 inline-flex items-center justify-center size-14 rounded-[var(--radius-sm)] bg-primary/10 text-primary">
                  <solution.icon className="size-7" />
                </div>
                <CardTitle className="mb-3 font-display font-semibold text-xl leading-tight">
                  {solution.title}
                </CardTitle>
                <CardDescription className="leading-[1.6] text-muted-foreground">
                  {solution.description}
                </CardDescription>
              </CardHeader>

              <CardContent className="px-0 pb-0">
                <Link to={solution.link} className="inline-flex items-center gap-2 font-semibold text-accent hover:text-accent-hover transition-colors duration-[var(--duration-fast)] group/link">
                  <span>Read More</span>
                  <ArrowRight className="size-4 transition-transform duration-[var(--duration-medium)] ease-[var(--ease-smooth)] group-hover/link:translate-x-1" />
                </Link>
              </CardContent>
            </Card>)}
        </div>

        <div className="mt-16 text-center">
          <Link to="/ContactPage">
            <Button size="lg" className="bg-accent text-foreground-accent hover:bg-accent-hover hover:scale-[1.02] active:bg-accent-active active:scale-[0.98] shadow-soft hover:shadow-medium transition-all duration-[var(--duration-fast)] ease-[var(--ease-smooth)]">
              Get Started
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}